import type { PurchaseOrderInvoiceLineDetails } from "@shared/types/payout";

export const setExpandablePOLineItemTestId = (identifier: string): string => `expandable-po-line-item-${identifier}`;

export const setExpandablePOLineItemRowTestId = (purchaseOrderId: string): string =>
  setExpandablePOLineItemTestId(`row-${purchaseOrderId}`);

export const setExpandablePOLineItemCellTestId = (purchaseOrderId: string, key: string): string =>
  setExpandablePOLineItemTestId(`cell-${purchaseOrderId}-${key}`);

export const setExpandablePOLineItemToggleButtonTestId = (purchaseOrderId: string): string =>
  setExpandablePOLineItemTestId(`toggle-${purchaseOrderId}`);

export const setExpandablePOLineItemDetailsHeadingTestId = (purchaseOrderId: string): string =>
  setExpandablePOLineItemTestId(`details-heading-${purchaseOrderId}`);

export const setExpandablePOLineItemDetailsCellTestId = (purchaseOrderId: string, rowIndex: number, key: string): string =>
  setExpandablePOLineItemTestId(`details-cell-${purchaseOrderId}-${rowIndex}-${key}`);

export const setExpandablePOLineItemExportButtonTestId = (purchaseOrderId: string): string =>
  setExpandablePOLineItemTestId(`export-button-${purchaseOrderId}`);

export const shouldFetchPurchaseOrderDetails = (
  isExpanded: boolean,
  isLoading: boolean,
  poDetails: PurchaseOrderInvoiceLineDetails[] | null
): boolean => !isLoading && !isExpanded && !poDetails;

export const getPurchaseOrderDetailsErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : "Failed to load details";
